module.exports = __webpack_public_path__ + "img/5_uk.83ecc414.svg";